module.exports = __webpack_public_path__ + "img/知识库.4b09cc46.jpg";